export default {"src":"/_next/static/media/ramassages-des-feuilles-mortes.c9e78bbe.svg","height":64,"width":108,"blurWidth":0,"blurHeight":0};